module.exports = __webpack_public_path__ + "img/zhuanpan1.30ba30dc.png";